// folderDropdown.ts
import { Dropdown } from "./dropdown";

export class UserDropdown extends Dropdown<null> {
    
    constructor() {
        super('userDropdownBtn', 'userDropdownMenu', 'userDropdownLabel');
    }

    protected onOpen = () => {
        console.log('Октрыт')
    };

    protected onClose = () => {
        console.log('Закрыт')
    };
}